<div class="ibox detailed-view-ibox" #mainComponent>
    <div class="detailed-view-header" #header>
        <div class="detailed-view-amenity-name">{{ds.selectedItemData?.name}}</div>
        <span class="close-detailed-view" (click)="ds.toggleDetailedView(null)">×</span>
    </div>
    <div class="detailed-view-wrap" [style.height]="mainComponent.clientHeight - header.clientHeight + 'px'">
        <div class="detailed-view-body">
            <div class="detailed-view__more-info m-t-md">
                <form #form="ngForm"
                      [ngClass]="{'ng-submitted': form.submitted}"
                      autocomplete="off">
                    <div class="tab-content" *ngIf="navPosition == 'details'">
                        <div class="row m-b-xs">
                            <div class="col-md-3">
                                <label>Type</label>
                            </div>
                            <div class="col-md-9">{{ds.selectedItemData.type === 'directory' ? 'Folder' : 'File'}}</div>
                        </div>

                        <div class="row m-b-xs clickable"
                             *ngIf="!authenticationService.userIsResident && 
                                    !(corporationNumbers.length == 1 &&
                                    ds.selectedItemData.corporationNumbers.length == 1)"
                             (dblclick)="editOnCorporationsAndBuildings()">
                            <div class="col-md-3">
                                <label>Corporations</label>
                            </div>
                            <div *ngIf="!ds.formFields.corporations" class="col-md-9">
                                <ng-container
                                    *ngFor="let corporation of ds.selectedItemData.corporationNumbers; let last = last;">
                                    {{ corporation.name + (!last ? ', ' : '') }}
                                </ng-container>
                                <span *ngIf="ds.selectedItemData.corporationNumbers.length < 1">-</span>

                                <i class="fa fa-pencil pull-right"
                                   *ngIf="ds.selectedItemData.isCanEdit"
                                   (click)="editOnCorporationsAndBuildings()"
                                   data-toggle="tooltip" data-placement="top" title="Edit"></i>
                            </div>
                            <div *ngIf="ds.formFields.corporations" class="col-md-7">
                                <angular2-multiselect name="corporationNumbers"
                                                      [data]="corporationNumbers"
                                                      [(ngModel)]="ds.selectedItemData.corporationNumbers"
                                                      (onSelect)="getBuildingsForSelectedCorporations()"
                                                      (onDeSelect)="getBuildingsForSelectedCorporations($event, 'deselect')"
                                                      (onSelectAll)="getBuildingsForSelectedCorporations()"
                                                      (onDeSelectAll)="getBuildingsForSelectedCorporations($event, 'deselectAll')"

                                                      (ngModelChange)="ds.onCorporationChange($event)"
                                                      [settings]="ds.multiselectSettings">
                                </angular2-multiselect>
                            </div>
                            <div *ngIf="ds.formFields.corporations"
                                 style="padding: 0;"
                                 class="col-sm-2 m-t-xs apart-btns pull-right">
                                <button type="button" class="apply" (click)="submitData()">
                                    <i class="fa fa-check"></i>
                                </button>

                                <button type="button" class="reset" (click)="editOffCorporationsAndBuildings()">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>

                        <div class="row m-b-xs clickable"
                             *ngIf="!authenticationService.userIsResident && buildings.length &&
                                    !(buildings.length == 1 &&
                                    ds.selectedItemData.buildings.length == 1)"
                             (dblclick)="editOnCorporationsAndBuildings()">
                            <div class="col-md-3">
                                <label>Buildings</label>
                            </div>
                            <div class="col-md-9" *ngIf="!ds.formFields.buildings">
                                <span *ngFor="let building of ds.selectedItemData.buildings; let last = last;">
                                    {{ building.name + (!last ? ', ' : '') }}
                                </span>
                                <span *ngIf="ds.selectedItemData.buildings.length < 1">-</span>

                                <i class="fa fa-pencil pull-right"
                                   *ngIf="ds.selectedItemData.isCanEdit"
                                   (click)="editOnCorporationsAndBuildings()"
                                   data-toggle="tooltip" data-placement="top" title="Edit"></i>
                            </div>
                            <div *ngIf="ds.formFields.buildings" class="col-md-7">
                                <angular2-multiselect name="buildings"
                                                      [data]="buildings"
                                                      [(ngModel)]="ds.selectedItemData.buildings"
                                                      [settings]="ds.multiselectSettings">
                                </angular2-multiselect>
                            </div>
                            <div *ngIf="ds.formFields.buildings"
                                 style="padding: 0;"
                                 class="col-sm-2 m-t-xs apart-btns pull-right">
                                <button type="button" class="apply" (click)="submitData()">
                                    <i class="fa fa-check"></i>
                                </button>

                                <button type="button" class="reset" (click)="editOffCorporationsAndBuildings()">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row m-b-xs">
                            <div class="col-md-3">
                                <label>Size</label>
                            </div>
                            <div
                                class="col-md-9">{{transformSize(ds.selectedItemData.size || ds.selectedItemData.totalSize)}}</div>
                        </div>

                        <div class="row m-b-xs">
                            <div class="col-md-3">
                                <label>From</label>
                            </div>
                            <div class="col-md-9">
                                {{ ds.selectedItemData.createdBy ? ds.selectedItemData.createdBy.fullName : '' }}
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Created</label>
                            </div>
                            <div class="col-md-9">
                                {{ ds.selectedItemData.createdAt | date:'dd.MM.yyyy hh:mm a'}}
                            </div>
                        </div>

                        <sharing-form-fields *ngIf="!authenticationService.userIsResident"
                                             [isCanEdit]="!authenticationService.userIsResident"
                                             [(isEditMode)]="ds.formFields.sharing"
                                             [(selectedItem)]="ds.selectedItemData"
                                             (sharingOptionsChange)="submitData($event)">
                        </sharing-form-fields>

                        <datetime-field
                            [classLabel]="'dv-label col-md-3 strong'"
                            [classValueBox]="'dv-value col-sm-9'"
                            [classValueEditBox]="'dv-value-edit col-sm-9'"
                            [title]="'Visible From'"
                            [(ngModel)]="acceptableFrom"
                            (ngModelChange)="onAcceptableFromChange($event)"
                            [ngModelOptions]="{standalone: true}"
                            [noEdit]="!ds.selectedItemData.isCanEdit"
                            (update)="saveAcceptableDates()"
                            (canceled)="revertAcceptableDates()"
                        >
                        </datetime-field>

                        <datetime-field
                            [classLabel]="'dv-label col-md-3 strong'"
                            [classValueBox]="'dv-value col-sm-9'"
                            [classValueEditBox]="'dv-value-edit col-sm-9'"
                            [title]="'Visible To'"
                            [(ngModel)]="acceptableTo"
                            (ngModelChange)="onAcceptableToChange($event)"
                            [ngModelOptions]="{standalone: true}"
                            [noEdit]="!ds.selectedItemData.isCanEdit"
                            (update)="saveAcceptableDates()"
                            (canceled)="revertAcceptableDates()"
                        >
                        </datetime-field>

                    </div>
                    <div class="tab-content" *ngIf="navPosition == 'history'">
                        <div class="timeline remove-vertical-scrollbar" style="padding: 30px 40px;">
                            <spinner [spinnerShow]="ds.spinnerShow"></spinner>
                            <ul class="timeline__list list-sideline-fix no-bottom-gap" *ngIf="!ds.spinnerShow">
                                <li *ngFor="let a of ds.activities" class="side-border-fix">
                                    <section *ngIf="a.action !== 'ignore'">
                                        <header class="timeline__header">
                                            <span>
                                                <time>{{ a.loggedAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.userFullName }}
                                            </span>
                                        </header>

                                        <main class="timeline__content">
                                            <div [ngSwitch]="a.action">
                                                <ng-template [ngSwitchCase]="'update'">
                                                <span>
                                                    {{ a.activityType }}
                                                    <span class="timeline__active">"{{a.name}}"</span>
                                                </span>
                                                    <ul class="field-changes">
                                                        <li *ngFor="let item of a.data">
                                                            {{ item?.key }} :
                                                            <span class="timeline__active">"{{ item?.old }}"</span>
                                                            changed to
                                                            <span class="timeline__active">"{{ item?.new }}"</span>
                                                        </li>
                                                    </ul>
                                                </ng-template>

                                                <ng-template [ngSwitchCase]="'create'">
                                                    <p>
                                                        {{ a.activityType }}
                                                        <span class="timeline__active">"{{a.data[0].value}}"</span> was
                                                        added
                                                        <span class="timeline__active">"{{a.name}}"</span>
                                                    </p>

                                                    <ul class="field-changes">
                                                        <li *ngFor="let item of a.data">
                                                            {{ item.key }} :
                                                            <span class="timeline__active">{{ item.value }}</span>
                                                        </li>
                                                    </ul>
                                                </ng-template>
                                            </div>
                                        </main>
                                    </section>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <hr>

                    <div class="btn-group dropup">
                        <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                            Actions <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu">
                            <li *ngIf="ds.selectedItemData.type === 'file'"
                                (click)="onClick('show')">
                                <a>View Document</a>
                            </li>
                            <li *ngIf="ds.selectedItemData.type === 'file'">
                                <a [href]="ds.selectedItemData?.path" [download]="ds.selectedItemData?.name">
                                    Download Document
                                </a>
                            </li>
                            <li *ngIf="ds.selectedItemData.type === 'directory'"
                                (click)="onClick('show')">
                                <a>Open Folder</a>
                            </li>
                            <!--<li *ngIf="ds.selectedItemData.isOpen">-->
                            <!--<a>Close Document</a>-->
                            <!--</li>-->
                            <li *ngIf="ds.selectedItemData.isCanEdit"
                                (click)="onClick('edit-permissions')">
                                <a>Edit</a>
                            </li>
                            <li *ngIf="ds.selectedItemData.isCanDelete"
                                (click)="onClick('remove')">
                                <a>Delete</a>
                            </li>
                            <li *ngIf="ds.selectedItemData.isCanEdit"
                                (click)="onClick('move')">
                                <a>Move</a>
                            </li>
                        </ul>
                    </div>
                </form>
            </div>
            <div *ngIf="!ds.selectedItemData">
                <spinner [spinnerShow]="true"></spinner>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-detailed-view/documents-detailed-view.component.html